<div *ngIf="data.typeError.toString() === 'INFO'">
  <table>
    <tr>
      <td><mat-icon class="green-icon">check_circle</mat-icon></td>
      <td>&nbsp;{{ data.menssage }}</td>
    </tr>
  </table>
</div>

<div *ngIf="data.typeError.toString() === 'ERROR'">
  <table>
    <tr>
      <td><mat-icon class="red-icon">error</mat-icon></td>
      <td>&nbsp;{{ data.menssage }}</td>
    </tr>
  </table>
</div>

<div *ngIf="data.typeError.toString() === 'WARNING'">
  <table>
    <tr>
      <td><mat-icon class="yellow-icon">warning</mat-icon></td>
      <td>&nbsp;{{ data.menssage }}</td>
    </tr>
  </table>
</div>
